import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  ClaimType, ErrorCode, ErrorCodeToSpecialText, NEED_TO_ADD_TRACKING_NUMBER,
} from '@constants';
import { useBehaviorData } from '@hooks';
import { logError } from '@log';
import { setDelayPackageId, setPackageList } from '@store';
import { getPackage } from '@api';

export const useDelay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const {
    fulfilledItems,
    unFulfilledItems, orderName, delayPackageId, type, policyId,
  } = useSelector((state) => state.claim);
  // const { getReviewData } = useReviewData();
  const setReportData = useBehaviorData();
  const { platform, specialPlatform } = useSelector((state) => state.policy);
  const [open, setOpen] = useState(false);
  const [packageId, setPackageId] = useState('');
  const [fulfillmentInfo, setFulfillmentInfo] = useState({});
  const isNeedToAddTracking = NEED_TO_ADD_TRACKING_NUMBER.includes(specialPlatform);

  // const onChange = (event) => {
  //   dispatch(setDelayPackageId(event?.target?.value));
  // };

  const onChange = (event, item) => {
    if ((!item.trackingNumber && isNeedToAddTracking)) {
      setOpen(true);
      setPackageId(event.target.value);
      setFulfillmentInfo({
        fulfillmentId: item.fulfillmentId,
      });
    } else {
      dispatch(setDelayPackageId(event?.target?.value));
    }
  };

  const onClickTitle = (item) => {
    dispatch(setDelayPackageId(item.fulfilledId));
  };

  const onClickContinue = async () => {
    try {
      setReportData({ chooseItemsTime: `${Date.now()}`, issueType: ClaimType.Delay });

      setIsLoading(true);
      if (!delayPackageId) {
        logError(new Error('delay onClickContinue no package'));
        return;
      }
      navigate('../payment');

      // const isSuccess = await getReviewData();

      // setIsLoading(false);
      // if (isSuccess) {
      //   navigate('../review');
      //   return;
      // }
      // navigate('../error', { state: { code: ErrorCode.Wrong } });
    } catch (error) {
      logError(error);
    }
  };

  const onClickBack = () => {
    dispatch(setDelayPackageId(''));
  };
  const handleOK = async () => {
    setOpen(false);
    const resp = await getPackage({ policyId, issueType: type });
    const { code, data } = resp;
    if (code === 0) {
      dispatch(setPackageList(data));
      const currentItem = data.fulfilledItems.find((ful) => ful.fulfillmentId === fulfillmentInfo.fulfillmentId)?.items[0];
      if (!fulfillmentInfo.isUnfulfilled && currentItem?.isInEffectivePeriod) {
        dispatch(setDelayPackageId(packageId));
      }
    } else if (ErrorCodeToSpecialText.includes(code)) {
      navigate('../error', { state: { code, type } });
    } else {
      navigate('../error', { state: { code: ErrorCode.Wrong } });
    }
  };

  const handleShippingClick = (fulfillmentId, isUnfulfilled) => {
    setOpen(true);
    setFulfillmentInfo({ fulfillmentId, isUnfulfilled });
  };
  return {
    fulfilledItems,
    unFulfilledItems,
    isBtnDisable: !delayPackageId,
    delayPackageId,
    orderName,
    isLoading,
    platform,
    specialPlatform,
    packageId,
    open,
    fulfillmentInfo,
    onChange,
    handleOK,
    handleShippingClick,
    handleClose: () => setOpen(false),
    onClickTitle,
    onClickContinue,
    onClickBack,
  };
};
